const R = globalThis.ReactDOM;
export const createPortal = R.createPortal;
export const flushSync = R.flushSync;
export const preconnect = R.preconnect;
export const prefetchDNS = R.prefetchDNS;
export const preinit = R.preinit;
export const preinitModule = R.preinitModule;
export const preload = R.preload;
export const preloadModule = R.preloadModule;
export const requestFormReset = R.requestFormReset;
export const version = R.version;
export default R;
export const render = R.render;
export const unmountComponentAtNode = R.unmountComponentAtNode;